import { Text } from '@chakra-ui/react'

export default function StatusBadge({ label, color }) {
  return (
    <Text
      fontSize="xs"
      fontWeight="semibold"
      px={2}
      py={0.5}
      borderRadius="full"
      border="1px solid"
      borderColor={color}
      color={color}
      textTransform="capitalize"
      textAlign="center"
    >
      {String(label).replace(/_/g, ' ')}
    </Text>
  )
}
